<template>
    <div>
        <header-portrate />
        <exports-print ref="exportbar" />

        <div>
            <bread-crumbs :items='items' />
            <tabsComp :tabs="tabs" />
            <v-row class="mt-10 mainrow m-2">
        <v-col
          cols="12"
          md="10"
          sm="12">
          <form autocomplete="off">
          <v-row >
            <v-col cols="12" md="2" sm="12" style="display:none">
              <label>{{lang.start_date}}</label>
              <b-input-group>
                <b-form-select class="inborder text-center" style="width:33%;background:#c3d9ff;" v-model="sd.day" :options="daysList"/>
                <b-form-select class="inborder text-center" style="width:33%;background:#c3d9ff;border-right:none !important;" v-model="sd.month" :options="monthsList" />
                <b-form-select class="inborder text-center" style="width:33%;background:#c3d9ff;" v-model="sd.year" :options="yearsList" />
              </b-input-group>
            </v-col>
            <v-col cols="12" md="2" sm="12" style="display:none">
              <label>{{lang.end_date}}</label>
              <b-input-group>
                <b-form-select class="inborder text-center" style="width:33%;background:#c3d9ff;" v-model="ed.day" :options="daysList" />
                <b-form-select class="inborder text-center" style="width:33%;background:#c3d9ff;border-right:none !important;" v-model="ed.month" :options="monthsList" />
                <b-form-select class="inborder text-center" style="width:33%;background:#c3d9ff;" v-model="ed.year" :options="yearsList" />
              </b-input-group>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <label>{{ lang.search }}</label>
              <b-input-group>
                <b-form-input class="inborder" v-model="search" style="background:#c3d9ff;" />
              </b-input-group>
            </v-col>

            <v-col cols="12" md="2" sm="12" style="display:none">
              <label></label>
              <b-input-group style="margin-top:-5px">
                <b-button variant="light" style="background:blue;color:#fff;width:75px;"  @click="getCurrentCards()">{{lang.search}}</b-button>
              </b-input-group>
            </v-col>
          </v-row>

        </form>
        </v-col>
        <v-col cols="12" md="2" sm="12" class="text-end pt-7" style="display:none">
          <b-button
              v-b-toggle.add_new_card
              class="btn-sm btn "
              @click="resetAllValues()"
              style="margin-top:9px;width:165px;background:transparent;border:none !important;margin-left:-7px !important;"
              id="multiply-button"
            >
              <div :class="`multiply-button-content-`+lang.lalgin" style="width:150px;border:none !important">{{lang.add_maint_request}}</div>
          </b-button>
        </v-col>
      </v-row>
        <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-bottom:50px !important;`">
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :search="search"
                    :items="tablerows"
                    :items-per-page="-1"
                    class="elevation-1"
                    hide-default-footer
                    fixed-header
                >
                <template v-slot:item="row">
                    <tr>
                        <td style="width:100px;text-align:center;">{{ row.item.cardid }}</td>
                        <td :style="`width:100px;text-align:center;${row.item.bgStyle}`">{{ row.item.exp_date }}</td>
                        <td style="text-align:center;">{{ row.item.license_type }}</td>
                        <td style="text-align:center;">{{ row.item.mobile1 }}</td>
                        <td style="text-align:center;">{{ row.item.mobile2 }}</td>
                        <td style="text-align:center;">{{ row.item.mobile3 }}</td>
                        <td>{{ row.item.company_name }}</td>
                        <td :style="`text-align:center;${row.item.last_invoice.style}`">{{ row.item.last_invoice.L }}</td>
                        <td style="text-align:center;">{{ row.item.city }}</td>
                        <td style="text-align:center;">{{ row.item.domain }}</td>
                        <td style="width:85px;background:blue;border: 2px solid #fff !important;">
                            <div class="viewBTN" @click="getReq(row.item.domain, row.item.exp_date)" v-b-toggle.customer_crm>
                                مطالبة</div>
                        </td>
                        <td style="width:85px;background:blue;border: 2px solid #fff !important;">
                            <div class="viewBTN" v-if="row.item.customerid != 0" @click="getCus(row.item.customerid)" v-b-toggle.customer_crm>
                                {{lang.action}}</div>
                        </td>
                    </tr>
                </template>
                </v-data-table>
            </v-col>
        </v-row>
        </div>
        <customerCRM ref="customerRef" />
        <Footer />
    </div>
</template>

<script>
import BreadCrumbs from '@/components/breadCrumbs.vue'
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
import tabsComp from '@/components/tabsComp.vue'
import ExportsPrint from '@/components/exports-print.vue';
import customerCRM from '@/components/customerCRM.vue'
import axios from 'axios'
import { getVisibleTabsForRoute } from '@/menu/menuService'
export default{
    components: {BreadCrumbs,HeaderPortrate,Footer,tabsComp,ExportsPrint,customerCRM},
    data(){
        return {
            sd: {
                day: 1,
                month: 1,
                year: (new Date()).getFullYear()
            },
            ed: {
                day: (new Date()).getDate(),
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear()
            },
            tablerows: [],
            search: '',
        }
    },
    computed:{
      lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
      sdate: function() {
        return (new Date(this.sd.year,this.sd.month-1, this.sd.day+1)).toISOString().substring(0,10);
      },
      edate: function() {
        return (new Date(this.ed.year,this.ed.month-1, this.ed.day+1)).toISOString().substring(0,10);
      },
      yearsList: function(){
        const start_year = this.$store.state.licenseType.startYear;
        let t = [{text: this.lang.year, value: -1}];
        for(let i=0;i<100;i++){
          if(parseInt(start_year) + i <= (new Date()).getFullYear()){
            t.push({text: start_year + i, value: start_year+i})
          }

        }
        return t
      },
      daysList: function(){
        return [
          {text: this.lang.day, value: -1},
          {text: 1, value: 1},
          {text: 2, value: 2},
          {text: 3, value: 3},
          {text: 4, value: 4},
          {text: 5, value: 5},
          {text: 6, value: 6},
          {text: 7, value: 7},
          {text: 8, value: 8},
          {text: 9, value: 9},
          {text: 10, value: 10},
          {text: 11, value: 11},
          {text: 12, value: 12},
          {text: 13, value: 13},
          {text: 14, value: 14},
          {text: 15, value: 15},
          {text: 16, value: 16},
          {text: 17, value: 17},
          {text: 18, value: 18},
          {text: 19, value: 19},
          {text: 20, value: 20},
          {text: 21, value: 21},
          {text: 22, value: 22},
          {text: 23, value: 23},
          {text: 24, value: 24},
          {text: 25, value: 25},
          {text: 26, value: 26},
          {text: 27, value: 27},
          {text: 28, value: 28},
          {text: 29, value: 29},
          {text: 30, value: 30},
          {text: 31, value: 31},
        ]
      },
      monthsList: function(){
        return [
          {text: this.lang.chose_month, value: -1},
          {text: 1, value: 1},
          {text: 2, value: 2},
          {text: 3, value: 3},
          {text: 4, value: 4},
          {text: 5, value: 5},
          {text: 6, value: 6},
          {text: 7, value: 7},
          {text: 8, value: 8},
          {text: 9, value: 9},
          {text: 10, value: 10},
          {text: 11, value: 11},
          {text: 12, value: 12},
        ]
      },
      items:function() {
          return {
            text: this.lang.invoices,
            disabled: true,
            href: '/invoicelist/',
          }
      },
      tabs: function() {

          return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);

      },
      headers: function(){
        let t=[]
        t.push({
              text: "#",
              align: 'center',
              filterable: false,
              value: 'cardid',
              sortable: false,
              class: 'pa-0 backBlack'
        })
        t.push({
              text: "تاريخ الانتهاء",
              align: 'center',
              filterable: true,
              value: 'exp_date',
              sortable: false,
              class: 'pa-0 backBlack'
        })
        t.push({
              text: "نوع الترخيص",
              align: 'center',
              filterable: true,
              value: 'license_type',
              sortable: false,
              class: 'pa-0 backBlack'
        })
        t.push({
              text: "رقم الاتصال",
              align: 'center',
              filterable: true,
              value: 'mobile1',
              sortable: false,
              class: 'pa-0 backBlack',
        })
        t.push({
              text: "رقم الاتصال",
              align: 'center',
              filterable: true,
              value: 'mobile2',
              sortable: false,
              class: 'pa-0 backBlack',
        })
        t.push({
              text: "رقم الاتصال",
              align: 'center',
              filterable: true,
              value: 'mobile3',
              sortable: false,
              class: 'pa-0 backBlack',
        })
        t.push({
              text: "اسم العميل",
              align: 'center',
              filterable: true,
              value: 'company_name',
              sortable: false,
              class: 'pa-0 backBlack'
        })
        t.push({
              text: "أخر فاتورة",
              align: 'center',
              filterable: true,
              value: 'last_invoice',
              sortable: false,
              class: 'pa-0 backBlack'
        })
        t.push({
              text: "المدينة",
              align: 'center',
              filterable: false,
              value: 'city',
              sortable: false,
              class: 'pa-0 backBlack'
        })
        t.push({
              text: "الرابط",
              align: 'center',
              filterable: false,
              value: 'domain',
              sortable: false,
              class: 'pa-0 backBlack'
        })
        t.push({
              text: "مطالبة",
              align: 'center',
              filterable: false,
              value: 'domain',
              sortable: false,
              class: 'pa-0 backBlack'
        })
        t.push({
              text: "الاجراء",
              align: 'center',
              filterable: false,
              value: 'domain',
              sortable: false,
              class: 'pa-0 backBlack'
        })
        return t;
      }
    },
    methods: {
        getReq(domain, exp_date){
            window.open("https://crm.samcotec.com/api/print.php?renew&domain="+domain+"&expired="+exp_date);
        },
        getCus(id){
            this.$refs.customerRef.customerid = id;
            this.$refs.customerRef.getCustomerInfo();
        },
        getClients(){
            let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
            const path = this.$router.currentRoute.path;
            let post = new FormData();
            post.append('type','getOldClients');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',cook);
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
            post.append("data[id]",1)
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                if(response && response.data && response.data.results && response.data.results.data){
                    this.tablerows = response.data.results.data
                }
            })
        }
    },
    created(){
        this.getClients();
    }
}
</script>